module.exports = __webpack_public_path__ + "static/media/confidencialidad.3ecb3368.svg";